//
//
//
//
export default {
  mounted: function mounted() {
    this.$store.dispatch("profile/SELECT_PROVIDER", this.$route.params.id);
    this.$router.back();
  }
};